<template>
    <AudioVue :audio="audio" :blue="blue" :purple="purple" @update="updateEvt" v-if="model">
        <div class="snapshot" :class="{capture: isCapture}" />
    </AudioVue>
</template>

<script>
import AudioVue from '@/tm/Audio'
import Audio from '@/tm/Audio/scripts/audio.js'
import CustomTmAudio from '@/utils/src/CustomTmAudio';

export default {
    name: 'AudioModel',
    emits: ['result', 'start'],
    props:{
        blue: {
            type: Boolean,
            default: false,
        },
        purple: {
            type: Boolean,
            default: false,
        },
        model: {
            type: Object,
            default: new CustomTmAudio()
        },
    },
    components: {
        AudioVue
    },
    data(){
        return {
            audio: new Audio(),
            isFirst: true,
            isCapture: false
        }
    },
    methods: {
        async updateEvt(data){
            this.isCapture = true
            setTimeout(() => {
                this.isCapture = false
            }, 150)

            if (!this.model.model) {
                return
            }
            if (this.isFirst) {
                this.isFirst = false
                this.$emit('start')
            }
            const result = await this.model.predict(data)
            
            const labels = this.model.model.words
            if (result?.length == labels?.length) {
                const output = labels.map((value, index) => {
                    return {
                        className: value,
                        probability: result[index],
                    };
                });
                this.$emit('result', output)
            }
        }
    },
    mounted(){
    }
}
</script>

<style scoped>
.layer{
    position: absolute; 
    bottom: 0;
    width: 240px; height: 240px;
}

.snapshot{
    border: 3px solid rgb(255,255,255, 0.9);
    width: 43px; height: 100%; background: rgba(255,255,255,0); 
    position: absolute; z-index: 1; top: 0; right: -1px; border-radius: 0;
    transition: background .15s ease-in-out;
}

.snapshot.capture{
    background: rgba(255,255,255,0.7); 
}
</style>